import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'ALQChild',
    label: 'ALQChild',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
